import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "booking-view transfer" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "space-wrapper" }
const _hoisted_6 = {
  key: 1,
  type: "button",
  class: "btn-primary",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_TransferOption = _resolveComponent("TransferOption")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("header", null, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelPageTransferStepHeadline']), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            class: "back-btn",
            title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
            to: { name: 'departure', query: _ctx.query }
          }, null, 8, ["title", "to"]),
          (_ctx.pageTexts['hotelPageTransferStepInfoPopup'])
            ? (_openBlock(), _createBlock(_component_EasyDrop, {
                key: 0,
                dropdownType: 'tooltip',
                position: 'right'
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "rte",
                    innerHTML: _ctx.pageTexts['hotelPageTransferStepInfoPopup']
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.searchBookingOverview.transfers.length === 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "rte",
            innerHTML: _ctx.obligatoryTransferText()
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.searchBookingOverview.transfers)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchBookingOverview.transfers, (transfer, index) => {
              return (_openBlock(), _createBlock(_component_TransferOption, {
                key: index,
                transfer: transfer,
                selectedTransferKey: _ctx.selectedTransferKey,
                localeStrings: _ctx.localeStrings,
                id: index.toString(),
                pageTexts: _ctx.pageTexts
              }, null, 8, ["transfer", "selectedTransferKey", "localeStrings", "id", "pageTexts"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.selectedTransferKey)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "btn-primary",
              to: { name: 'personal-data', query: _ctx.query }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("button", _hoisted_6, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)),
        _createVNode(_component_router_link, {
          class: "prev",
          to: { name: 'departure', query: _ctx.query }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonPrevious']), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}